const SERVICE_URL = process.env.REACT_APP_SERVICE_URL;

export const API = {
  datasets: `${SERVICE_URL}/datasetsApi`,
  filtersDropdown: `${SERVICE_URL}/filtersApi`,
  kpistimeframes: `${SERVICE_URL}/kpisApi`,
  datasetslist: `${SERVICE_URL}/get_datasets`,
  nielsen_dropdowns: `${SERVICE_URL}/get_dropdowns`,
  nielsen_kpis: `${SERVICE_URL}/get_kpis`,
  epos_dropdowns: `${SERVICE_URL}/get_epos_dropdowns`,
  epos_kpis: `${SERVICE_URL}/get_epos_kpis`,
  epos_kpis_page: `${SERVICE_URL}//get_epos_kpis_page`,
  table_preview: `${SERVICE_URL}/get_table_preview`,
  export_data: `${SERVICE_URL}/export_data`,
  apply_bookmark: `${SERVICE_URL}/bookmark`,
  save_bookmark: `${SERVICE_URL}/bookmark`,
  delete_bookmark: `${SERVICE_URL}/bookmark`,
  user_logs: `${SERVICE_URL}/user_logs`,
};
